var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('div', { staticClass: "app-container" }, [_c('el-tabs', { attrs: { "type": "border-card", "value": _vm.query.tag_type }, on: { "tab-click": _vm.handleTabClick } }, [_vm._l(_vm.tags, function (tag, index) {
    return [_c('permission-manager', { key: index, attrs: { "latchkey": tag.permissionKey } }, [_c('el-tab-pane', { attrs: { "label": tag.label, "name": tag.type } }, [_vm.query.tag_type === tag.type ? _c('tag-tree', { attrs: { "tagType": _vm.query.tag_type, "config": tag } }) : _vm._e()], 1)], 1)];
  })], 2)], 1);
};
var staticRenderFns = [];

export { render, staticRenderFns };